import React from 'react';
import { Button, Tabs, TabsList, TabsTrigger } from '@onward-delivery/design';
import { TARIFF_CATEGORY_GROUPS } from './constants';
import { TabsRow } from './blocks';

// Figma draws these tabs as a bordered rail with a green active tab, where the library's default
// pill uses a white one, so the list and triggers carry overrides (cn/twMerge lets them win). Each
// design-system piece sits in its own bare onward-design scope.
const LIST_CLASSES = 'h-10 border border-[#cacaca] bg-[#fcfcfc]';
const TRIGGER_CLASSES =
    'rounded-md px-2 text-[13px] data-[state=active]:bg-primary data-[state=active]:text-primary-fg data-[state=active]:shadow-[0px_2px_2px_0px_rgba(0,0,0,0.3)]';

const GroupTabs = ({ value, onChange, onAdd }) => (
    <TabsRow>
        <div className="onward-design">
            <Tabs value={value} onValueChange={onChange}>
                <TabsList className={LIST_CLASSES} aria-label="Tariff groups">
                    {TARIFF_CATEGORY_GROUPS.map((group) => (
                        <TabsTrigger key={group.value} value={group.value} className={TRIGGER_CLASSES}>
                            {group.label}
                        </TabsTrigger>
                    ))}
                </TabsList>
            </Tabs>
        </div>
        <div className="onward-design">
            <Button size="sm" onClick={onAdd}>
                Add Tariff
            </Button>
        </div>
    </TabsRow>
);

export default GroupTabs;
